




















































































































































import { Component, Prop, Vue, PropSync } from 'vue-property-decorator';
import { TransceiversApi, Transceiver, SensorsApi } from '../../api';
import TitleMixin from '@/mixins/title-mixin';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {},
	mixins: [TitleMixin],
})
export default class RawData extends Vue {
	@PropSync('customFilter')
	private localCustomFilter?: string;

	public currentPage = 1;
	public perPage = 100;
	public totalRows = 0;
	public rawData = [];
	public sortKey = '';
	public key = '';
	public active = '';
	@Prop(Number) public transceiverId?: number;
	@PropSync('checkInTime') public localCheckInTime!: string;
	public transceiver: any | null = null;
	public sensors: any[] | null = [];

	public fields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'fields', label: 'fields' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];
	public rawDataFields: any[] | null = [
		{ key: 'received', label: 'Received', sortable: true },
		{ key: 'data', label: 'Data' },
		{ key: 'topic', label: 'Topic' },
	];
	public quickFilterList = [
		'boot',
		'mains',
		'power',
		'fault',
		'cell',
		'ack',
		'init',
		'update',
		'milking',
		'pickup',
		'wash',
	];
	public form = { localCustomFilter: '' };
	private api: TransceiversApi;

	public vatIdToLabel(vId: any) {
		if (this.vats == null) {
			return vId;
		}
		for (const vat of this.vats) {
			if (vat.id === vId) {
				return vat.label;
			}
		}
		return vId;
	}

	public async load() {
		this.loading = true;
		try {
			const { data } = await new TransceiversApi().getTransceiverById(
				parseInt(this.transceiverId, 10),
				{
					params: {
						include: 'sensors,', // sensors
					},
				},
			);
			this.transceiver = data;
			this.sensors = data.sensors || {};
			this.reload(null, null, false);
		} catch (e) {
			console.log(e);
			this.transceiver = null;
		} finally {
			this.loading = false;
		}
	}

	public async deallocateSensor(sensor: Sensor) {
		try {
			const api = new SensorsApi();
			const response = await api.deallocateSensor(sensor.id);
		} catch (e) {
			console.log(e);
			new Toast().makeToast(
				`Sensor ${sensor.serialNumber} was not able to be deallocated`,
				'Sensor Not Deallocated',
				'Danger',
				false,
			);
		}
		this.load();
		new Toast().makeToast(
			`Successfully Deallocated Sensor ${sensor.serialNumber}`,
			'Sensor Successfully Deallocated',
			'success',
			false,
		);
	}

	public async reload(key: string, sortKey: string, prev = false) {
		const transceiverId = this.transceiverId;
		try {
			const api = new TransceiversApi();
			const response = await api.getTransceiverRawData(
				parseInt(transceiverId, 10),
				1000,
				this.sortKey,
				this.key,
			);
			this.rawData = this.rawData.concat(response.data);
			this.sortKey = this.rawData[this.rawData.length - 1].sortKey;
			this.key = this.rawData[this.rawData.length - 1].key;
			this.totalRows = this.rawData.length;
		} catch (e) {
			console.log(e);
		}
	}

	public onFiltered(filteredItems) {
		// Trigger pagination to update the number of buttons/pages due to filtering
		this.totalRows = filteredItems.length;
	}

	public created() {
		this.load();
	}
}
